var file_upload_viewer_default = {
  "fontElementMap": "hfA8g",
  "file_upload_container": "_89Z1T",
  "file_upload_link": "TjrKZ",
  "file_upload_error_container": "vXGPr",
  "file_upload_file_info": "ob2r0",
  "file_upload_type_icon": "oaPzi",
  "file_upload_status_icon_container": "FYDJ-",
  "file_upload_status_icon": "od39v",
  "file_upload_description": "-ZsoP",
  "file_upload_name_container": "_5PLGm",
  "file_upload_name": "dSqMw",
  "file_upload_extension": "TMqgi",
  "file_loader_icon": "q1xcO",
  "file_upload_icon_frame": "FZxjb",
  "file_upload_icon_background": "_1jVki"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
